<div class="modal-with-checkboxes-list-container">
  @if (dataModal) {
    <div class="header-container">
      <h2>{{ dataModal.texts.title }}</h2>
      <p>{{ dataModal.texts.subtitle }}</p>
      <span>{{ dataModal.texts.second_subtitle }}</span>
    </div>

    <div class="list-checkboxes">
      @for (element of dataModal.elements; track element) {
        <label class="checkbox" nz-checkbox [nzChecked]="element.selected" [nzValue]="element.label" (nzCheckedChange)="onCheckboxChange(element)">
          {{ element.label }}
        </label>
      }
    </div>

    <div class="container-buttons">
      <ds-button [text]="'buttons.exit' | translate" [styleType]="'empty-main'" [width]="'small'" (click)="onExit()"></ds-button>
      <ds-button [text]="'buttons.save' | translate" [width]="'small'" (click)="onSave()" [isDisabled]="!!!selectedCheckbox"></ds-button>
    </div>
  }
</div>

